import { Selector as GammaSelector } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type SelectorProps = React.ComponentProps<typeof GammaSelector.Popover>
type ContainerProps = React.ComponentProps<typeof GammaSelector.Container>

type Props = Omit<SelectorProps, 'selectValue' | 'missingLabel' | 'defaultSearchPlaceholder'> & {
  missingLabel?: string
  extra?: { 'data-intercom-target'?: string }
}

const Popover: React.FC<Props> = ({ missingLabel, extra, ...props }) => (
  <GammaSelector.Popover
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
    defaultSearchPlaceholder={i18n.t('common.search')}
    extra={extra}
  />
)

export default {
  Container: (props: Omit<ContainerProps, 'defaultSearchPlaceholder'>) => (
    <GammaSelector.Container {...props} defaultSearchPlaceholder={i18n.t('common.search')} />
  ),
  Option: GammaSelector.Option,
  Popover,
}
